import React from "react";

const Docs = (props) => {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"navIcon--docs"}</title>
      <path
        d="M35.6 9.499H34V7.042 6.96v-.082c0-.04 0-.04-.04-.082 0-.04 0-.04-.04-.081 0 0-.04-.041-.04-.082s-.04-.041-.04-.082l-.04-.041-.04-.041-.04-.041s-.04-.041-.08-.041-.04-.04-.08-.04-.04-.042-.08-.042h-.08c-.04 0-.04 0-.08-.04-4.64-.779-9.48.327-13.32 3.029a17.722 17.722 0 00-13.32-3.03c-.04 0-.08 0-.08.041h-.08c-.04 0-.04.041-.08.041s-.04 0-.08.041c-.04 0-.04.04-.04.04-.04 0-.04.042-.08.042l-.04.04-.04.042s-.04.04-.04.082c0 .04-.04.04-.04.082 0 .04 0 .04-.04.081 0 .041 0 .041-.04.082V9.5H4.4c-1.32 0-2.4 1.105-2.4 2.415v18.67A2.4 2.4 0 004.4 33h31.2c1.32 0 2.4-1.105 2.4-2.416V11.955c0-1.35-1.08-2.456-2.4-2.456zM4.4 31.403c-.44 0-.8-.368-.8-.819V11.955c0-.45.36-.819.8-.819H6v17.852c0 .245.12.45.28.614.16.163.4.204.64.163 3.52-.573 7.12 0 10.28 1.638H4.4zm14.8-.696a18.068 18.068 0 00-11.6-2.661V7.779c4.08-.532 8.24.532 11.6 2.948v19.98zm1.6-19.98c3.36-2.416 7.52-3.48 11.6-2.948v20.267c-4.04-.45-8.16.491-11.6 2.661v-19.98zm15.6 19.898c0 .45-.36.82-.8.82H22.8c3.12-1.639 6.76-2.212 10.28-1.639.24.041.48-.04.64-.163.2-.164.28-.369.28-.614V11.136h1.6c.44 0 .8.369.8.82v18.67z"
        fill="#5D8BFF"
        fillRule="nonzero"
      />
    </svg>
  );
};

export default Docs;
